import { z } from 'zod';

export const fileDeletedResSchema = z.object({
  id: z.string().nullable(),
  fileName: z.string().nullable(),
  errorMessage: z.string().nullable(),
  success: z.boolean().nullable()
});
export type FileDeletedRes = z.infer<typeof fileDeletedResSchema>;

export const fileInfoResSchema = z.object({
  id: z.string().nullable(),
  fileName: z.string().nullable(),
  fileType: z.string().nullable(),
  fileSize: z.number().nullable(),
  createUser: z.string().nullable(),
  createUserName: z.string().nullable(),
  createDatetime: z.string().nullable(),
  modifyDatetime: z.string().nullable()
});
export type FileInfoRes = z.infer<typeof fileInfoResSchema>;

export const fileUploadedResSchema = z.object({
  id: z.string().nullable(),
  fileName: z.string().nullable(),
  errorMessage: z.string().nullable(),
  success: z.boolean().nullable()
});
export type FileUploadedRes = z.infer<typeof fileUploadedResSchema>;

export const apiResponseListFileDeletedResSchema = z.object({
  msg: z.string().nullable(),
  msgArgs: z.array(z.string()).nullable(),
  err: z.number().nullable(),
  statusCode: z.number().nullable(),
  data: z.array(fileDeletedResSchema).nullable()
});
export type ApiResponseListFileDeletedRes = z.infer<typeof apiResponseListFileDeletedResSchema>;

export const apiPageResponseObjectSchema = z.object({
  msg: z.string().nullable(),
  msgArgs: z.array(z.string()).nullable(),
  err: z.number().nullable(),
  statusCode: z.number().nullable(),
  data: z.unknown().nullable(),
  totalPageSize: z.number().nullable(),
  totalItemSize: z.number().nullable(),
  currentPageItemSize: z.number().nullable(),
  pageSize: z.number().nullable()
});
export type ApiPageResponseObject = z.infer<typeof apiPageResponseObjectSchema>;

export const sseEmitterSchema = z.object({
  timeout: z.number().nullable()
});
export type SseEmitter = z.infer<typeof sseEmitterSchema>;

export const apiResponseFileInfoResSchema = z.object({
  msg: z.string().nullable(),
  msgArgs: z.array(z.string()).nullable(),
  err: z.number().nullable(),
  statusCode: z.number().nullable(),
  data: fileInfoResSchema.nullable()
});
export type ApiResponseFileInfoRes = z.infer<typeof apiResponseFileInfoResSchema>;

export const apiResponseListFileInfoResSchema = z.object({
  msg: z.string().nullable(),
  msgArgs: z.array(z.string()).nullable(),
  err: z.number().nullable(),
  statusCode: z.number().nullable(),
  data: z.array(fileInfoResSchema).nullable()
});
export type ApiResponseListFileInfoRes = z.infer<typeof apiResponseListFileInfoResSchema>;

export const apiResponseObjectSchema = z.object({
  msg: z.string().nullable(),
  msgArgs: z.array(z.string()).nullable(),
  err: z.number().nullable(),
  statusCode: z.number().nullable(),
  data: z.unknown().nullable()
});
export type ApiResponseObject = z.infer<typeof apiResponseObjectSchema>;

export const reqCrudSaveSchema = z.object({
  systemNo: z.string().min(1),
  tableName: z.string().min(1),
  tableData: z.preprocess((val) => val === undefined ? null : val, z.array(z.unknown()).nullish())
});
export type ReqCrudSave = z.infer<typeof reqCrudSaveSchema>;

export const apiResponseListFileUploadedResSchema = z.object({
  msg: z.string().nullable(),
  msgArgs: z.array(z.string()).nullable(),
  err: z.number().nullable(),
  statusCode: z.number().nullable(),
  data: z.array(fileUploadedResSchema).nullable()
});
export type ApiResponseListFileUploadedRes = z.infer<typeof apiResponseListFileUploadedResSchema>;

// Query Parameter Schemas

export const downloadFileQuerySchema = z.object({
  fileId: z.string()
});
export type DownloadFileQuery = z.infer<typeof downloadFileQuerySchema>;

export const queryQuerySchema = z.object({
  system: z.string(),
  tableName: z.string(),
  pageNum: z.number(),
  pageSize: z.number(),
  filters: z.string().nullish(),
  likes: z.string().nullish(),
  sorts: z.string().nullish()
});
export type QueryQuery = z.infer<typeof queryQuerySchema>;

export const queryStructureQuerySchema = z.object({
  system: z.string(),
  tableName: z.string()
});
export type QueryStructureQuery = z.infer<typeof queryStructureQuerySchema>;
